export default function Cv() {
  return (
    <section
      id="cv"
      className="portfolio__cv portfolio__elem"
    >
      <h2>Currículum Vitae</h2>
      <div className="cv__preview">
        <p className="cv__header">
          leodeslf-CV-2021.md
          <span className="cv__buttons"><span></span></span>
        </p>
        <p><em>&lt;!-- Vista previa: --&gt;</em></p>
        <h3>ORIENTACIÓN EDUCATIVA</h3>
        <p>
          <strong>EMT - Informática</strong> - <em>Escuela Superior de
            Informática</em>
        </p>
        <h3>FORMACIÓN COMPLEMENTARIA</h3>
        <p>
          <strong>Desarrollo Frontend</strong> - <em>Autodidacta</em><br />
          <strong>Testing Funcional de Software</strong> - <em>Fundación
            Forge</em>
        </p>
        <h3>IDIOMAS</h3>
        <p>
          <strong>Portugués</strong> - <em>Materno</em><br />
          <strong>Inglés</strong> - <em>Intermedio</em>
        </p>
        <p>
          [<a
            href="./res/Leonardo_de_SLF-Desarrollo_Frontend-CV_2021.pdf"
            title="Archivo PDF."
          >
            Ver PDF
          </a>](<em>leodeslf-CV-2021.pdf</em>).
          <span className="cv__blinking-cursor"></span>
        </p>
      </div>
    </section>
  );
}
